<app-header (found)="handleResults($event)"></app-header>
<div id="main-wrapper">
  <ngx-loading [show]="loadingDashboard" [config]="{ backdropBorderRadius: '14px' }"></ngx-loading>
  <div class="main-background topSpace main-container epahafContainer">
    <app-search-results [resultGridList]="data"></app-search-results>
    <div class="container-fluid dashboardViewEpahaf" style="padding: 0; ">
      <div class="tab homeAccrordian">


        <div class="reportContent whiteBg tableShadow" style="margin-bottom:50px">
          <!--<div style="text-align:left">
          <span class="fa fa-arrow-left" style="font-size:14px; color:#23499E;"></span> &nbsp;
          <button class="btn-transparent-carelon"(click)="goToHome()">Quick Links</button >
        </div> -->


        <div class="row" style = "margin-top:30px ; ">

          <div class=" col-md-9  " style = " font-size:30px !important;">
            Eligibility Report
          </div>
          <div class="col-md-3 ">



            <button
              class="reportBtn carelon-btn "
              style="width:290px"
              (click)="generateExcelReport()"
              title="Click here to generate Eligibility Report" [disabled]="checkedReportList.length==0">
              Generate Member Eligibility Report
            </button>

          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <div class="heading pull-left  col-md-6" style = "margin-top: 25px ;margin-bottom:15px;font-size:18px;color:black;">
              Member Details
            </div>
          </div>
          <div class="col-md-9"></div>
          <div class="col-md-3">
            <img src="assets/images/filterby.svg"> Filter by
          </div>
          <div class="col-md-9"></div>
        </div>




        <div>
          <div class="row mt-4"
            style="position: relative;">
            <div class=" form-group cup-dd-down-arrow cup-dd-down-screen-basis mutliSelectDropdown ms-3">
              <!-- <input
              class="form-control input-underline searchMember"
              placeholder="Search any  PCP Name/ Health Plan"
              [(ngModel)]="searchInput"
              (keyup)="filterMembers($event)"
              /> -->
              <div class="col-md-12  col-xs-12  rightPad0 pad0 posRelative row m-t-20 eligibilityReportFilter">
                <div class="col-md-3  col-xs-12 row">

                  <label class="p-0" for="provider">PCP Name</label>
                  <div class="multiSelect" style="border: 1px solid; ">
                    <angular2-multiselect id="eligibilityPCPList" style="border:1px rgb(85, 84, 84); padding:0px;"
                      [data]="dropdownListPCPlist" [(ngModel)]="selectedPCPItems" class="multiselect-dropdown-style form-control input-underline"
                      [settings]="getSettings('PCP')" (onSelect)="onItemSelect1($event)"
                      (onDeSelect)="OnItemDeSelect1($event)" (onSelectAll)="onSelectAll1($event)"
                      (onDeSelectAll)="onDeSelectAll($event)">
                    </angular2-multiselect>
                  </div>
                </div>
                <div class="col-md-3  col-xs-12 ">
                  <label for="provider">Health Plan</label>
                  <div class="multiSelect" style="border: 1px solid; ">

                    <angular2-multiselect id="eligibilityHealthList" style="border:1px rgb(85, 84, 84); padding:0px;"
                      [data]="dropdownListHealthPlan" [(ngModel)]="selectedHPItems"
                      class="multiselect-dropdown-style form-control input-underline" [settings]="getSettings('HP')"
                      (onSelect)="onItemSelect2($event)" (onDeSelect)="OnItemDeSelect2($event)"
                      (onSelectAll)="onSelectAll2($event)" (onDeSelectAll)="onDeSelectAll($event)">
                      <label>SEARCH MEMBER NAME / ID / PCP</label>
                    </angular2-multiselect>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="memberContainer dashboard-content mainreportTable">
          <div style="font-size:15px ; margin-bottom:15px; color:black; ">Selected Members Count:
            <b>{{checkedReportList.length}}</b></div>
            <table class="table custom-table myTable stcikyHeaders" id="myTable" cellspacing="0" cellpadding="0">
              <thead>
                <tr class="table-header stickyHeader">
                  <th class="checkBoxContainer">

                    <div>
                      <input type="checkbox" [(ngModel)]="masterSelected" name="list_name"
                        (change)="checkUncheckAll()" />

                      </div>
                    </th>
                    <th>PCP NPI</th>
                    <th>PCP Name

                    </th>
                    <th>Affiliated Group/ IPA</th>
                    <th>Member ID</th>
                    <th>Member Full Name</th>
                    <th>Member Date of Birth</th>
                    <th>Health Plan Name</th>


                  </tr>
                </thead>
                <tbody class="panels">
                  @for (
                    memberDetails of virtualLoadingMemberDetailData; track
                    memberDetails; let rowIndex = $index) {
                    @if (memberDetails.memberHmoID) {
                      <tr>
                        <td class="checkBoxContainer">
                          <input type="checkbox" [(ngModel)]="memberDetails.isSelected"
                            class="custom-control-input checkboxinput" #checkboxesSelect
                            (click)="$event.stopPropagation() "
                            [checked]="isChecked(memberDetails.memberHmoID,memberDetails.GROUP_IPA_POD_NAME)"
                            (change)="selectedMember(memberDetails, '', $event)" />
                          </td>
                          <td>{{memberDetails.npi}}</td>
                          <td>
                            {{memberDetails.pcpName}}
                          </td>
                          <td>{{memberDetails.group}}</td>
                          <td>
                            {{memberDetails.memberHmoID}}
                          </td>
                          <td>{{memberDetails.fullName}}</td>
                          <td>{{memberDetails.memberDOB}}</td>
                          <td>
                            {{memberDetails.HealthPlan}}
                          </td>
                        </tr>
                      } @else {
                        <tr>
                          <td colspan="9">No data found</td>
                        </tr>
                      }
                    }

                  </tbody>
                </table>
              </div>
              <div align="center" class="viewMoreBtn">
                <div colspan="9">
                  <button id="displays" (click)="loadmoreData()" class="viewMoreDisplay">
                    View More
                  </button>
                  <!-- <button id="searchInputDisplay" class="viewMoreDisplay searchInputViewMore">View More</button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



    </div>


    <app-footer></app-footer>